import React from "react";
import styles from "./MRBApprovalPDF.module.css";

const MRBApprovalPDF = ({ outwardData }) => {
  // Logo URL
  const logoUrl =
    "https://bermadimsapi.disctesting.in/uploads/logo/8e08ec4e6348fc2fe1f64ae147db7496.jpeg";

  // Extract data from the imported JSON

  const {
    type,
    outward_no,
    vehical_no,
    remark,
    project = {},
    warehouse = {},
    contractor = {},
    outward_items = [],
    createdBy = {},
    createdAt,
    outward_date,
    mrb_status,
  } = outwardData;

  // Group items while maintaining original order
  const processedItems = (() => {
    const groupedItems = {};
    const processedList = [];

    outward_items.forEach((item) => {
      if (!groupedItems[item.item_id]) {
        groupedItems[item.item_id] = {
          main: null,
          subItems: [],
        };
      }

      // If item is single and is_make_item is true, treat it as having a sub-item
      if (item.is_make_item) {
        if (!groupedItems[item.item_id].main) {
          groupedItems[item.item_id].main = item;
          // Add the item itself as a sub-item
          groupedItems[item.item_id].subItems.push(item);
        } else {
          groupedItems[item.item_id].subItems.push(item);
        }
      } else {
        // For non-make items
        if (!groupedItems[item.item_id].main) {
          groupedItems[item.item_id].main = item;
        } else {
          groupedItems[item.item_id].subItems.push(item);
        }
      }
    });

    // Convert to list while maintaining original order of first appearances
    const processedItemIds = new Set();
    outward_items.forEach((item) => {
      if (!processedItemIds.has(item.item_id)) {
        processedItemIds.add(item.item_id);
        processedList.push(groupedItems[item.item_id]);
      }
    });

    return processedList;
  })();

  // Predefined static totals
  const totalOutwardQty =
    outward_items &&
    outward_items?.reduce(
      (acc, item) => acc + (parseFloat(item?.outward_qty) || 0),
      0
    );

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const formatNumberWithBreaks = (num) => {
    if (!num && num !== 0) return "-";
    return parseFloat(num).toLocaleString("en-IN", {}).replace(/,/g, ",\u200B");
  };
  return (
    <div className={styles.mainContainer}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img src={logoUrl} alt="BERMAD" className={styles.logo} />
          <div className={styles.companyName}>
            BERMAD INDIA Private Limited.
          </div>
        </div>
        <div className={styles.addressRight}>
          <h2 className={styles.orderTitle}>MRB Approval Details</h2>
          <div>
            <strong>Project Name:</strong> {project?.project_name || "-"}
          </div>
          <div>
            <strong>Project Code:</strong> {project?.project_code || "-"}
          </div>
        </div>
      </div>

      <div className={styles.blueBar}></div>
      <table className={styles.orderHeader}>
        <thead>
          <tr>
            <th style={{ width: "33%", textAlign: "left" }}>Type</th>
            <th style={{ width: "33%", textAlign: "left" }}>Outward no:</th>
            <th style={{ width: "33%", textAlign: "left" }}>Outward date:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {type || "-"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {outward_no || "-"}
            </td>
            <td className={styles.cellNowrap} style={{ textAlign: "left" }}>
              {formatDate(createdAt) || "-"}
            </td>
          </tr>
        </tbody>
      </table>

      <table className={styles.termsTable}>
        <tbody>
          <tr>
            <td className={styles.labelCell}>Warehouse</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>
              {warehouse?.warehouse_name || "-"}
            </td>
            <td className={styles.labelCell}>Assigned By</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>
              {createdBy?.first_name && createdBy?.last_name
                ? `${createdBy.first_name} ${createdBy.last_name}`
                : "-"}
            </td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Assigned To</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>
              {contractor?.first_name && contractor?.last_name
                ? `${contractor.first_name} ${contractor.last_name}`
                : "-"}
            </td>
            <td className={styles.labelCell}>Vehicle No</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>{vehical_no || "-"}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Status</td>
            <td className={styles.colonCell}>:</td>

            <td className={styles.valueCell}>
              {type == "MRB" ? mrb_status?.toUpperCase() || "-" : "-"}
            </td>

            <td className={styles.labelCell}>Remark</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>{remark || "-"}</td>
          </tr>
        </tbody>
      </table>

      <table className={styles.catalogTable}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr No.</th>
            <th style={{ width: "25%" }}>Item Code</th>
            <th style={{ width: "10%" }}>UOM</th>
            <th style={{ width: "15%" }}>
              {type === "Scrab" ? "MRB QTY" : "Stock QTY"}
            </th>
            <th style={{ width: "15%" }}>
              {type === "Outward"
                ? "Outward QTY"
                : type === "MRB"
                ? "MRB QTY"
                : type === "Scrab"
                ? "Scrap QTY"
                : "QTY"}
            </th>
          </tr>
        </thead>
        <tbody>
          {processedItems.map((itemGroup, mainIndex) => (
            <React.Fragment key={itemGroup.main.item_id}>
              <tr>
                <td className={styles.textCenter}>{mainIndex + 1}</td>
                <td>
                  <div className={styles.itemDescription}>
                    <div className={styles.itemCode}>
                      {itemGroup.main.item_code || "N/A"}
                    </div>
                    <div className={styles.itemDesc}>
                      <span>Product Description:</span>
                      <br />
                      {itemGroup.main.is_make_item
                        ? itemGroup.main.make_item_desc
                        : itemGroup.main.description || "N/A"}
                    </div>
                  </div>
                </td>
                <td className={styles.textCenter}>
                  {itemGroup.main.is_make_item
                    ? itemGroup.main.make_item_uom
                    : itemGroup.main.uom || "N/A"}
                </td>
                <td className={styles.textRight}>
                  <div className={styles.numberWrapper}>
                    {itemGroup.main.is_make_item
                      ? "-"
                      : formatNumberWithBreaks(itemGroup.main.stock_qty) || "0"}
                  </div>
                </td>
                <td className={styles.textRight}>
                  <div className={styles.numberWrapper}>
                    {itemGroup.main.is_make_item
                      ? "-"
                      : formatNumberWithBreaks(itemGroup.main.outward_qty) ||
                        "0"}
                  </div>
                </td>
              </tr>

              {itemGroup.subItems.map((subItem, subIndex) => (
                <tr key={`sub-${subItem.id}`} className={styles.subItemRow}>
                  <td className={`${styles.textCenter} ${styles.subItemIndex}`}>
                    {`${mainIndex + 1}.${subIndex + 1}`}
                  </td>
                  <td>
                    <div className={styles.subItemCode}>
                      {subItem.buy_item_code || "N/A"}
                      <div className={styles.subItemDesc}>
                        <span>Product Description:</span>
                        <br />
                        {subItem.description || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className={styles.textCenter}>{subItem.uom || "N/A"}</td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(subItem.stock_qty) || "0"}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(subItem.outward_qty) || "0"}
                    </div>
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <div className={styles.totalsSectionRight}>
        <table className={styles.totalsTable}>
          <tbody>
            <tr className={styles.grandTotal}>
              <td className={styles.totalLabel}>TOTAL MRB QTY</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {formatNumberWithBreaks(totalOutwardQty)}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.clearFix}></div>
    </div>
  );
};

export default MRBApprovalPDF;
